import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import { CombineRoute } from '@shared/constants/RelativePath';
import { SecurityState } from '@shared/store/reducers/security.reducer';
import { hasFeature } from '@shared/store/selectors/security.selector';

import { EntityChartFeatures } from '../../entity-chart.features';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Component({
    standalone: false,
    selector: 'lib-app-entity-chart-toolbar',
  templateUrl: './entity-chart-toolbar.component.html',
  styleUrls: ['./entity-chart-toolbar.component.scss'],
})
export class EntityChartToolbarComponent implements OnInit {
  hasFeature$: Observable<any>;
  entityChartFeatures = EntityChartFeatures; // used in the html view to check the permission.

  constructor(private router: Router, private securityStore: Store<SecurityState>) { }

  ngOnInit() {
    this.hasFeature$ = this.securityStore.pipe(select(hasFeature));
  }

  navigateToImportEntities() {
    console.log('ImportEntityChart');
    this.router.navigate(CombineRoute.EntityChartImportRoute);
  }
}
